module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center_right right_auth"
  }, [_c('div', {
    staticClass: "center_tag"
  }, [_c('ul', {
    staticClass: "left"
  }, _vm._l(([{
      title: '老师',
      id: 'dubber'
    },
    {
      title: '声音',
      id: 'voice'
    },
    {
      title: '合辑',
      id: 'album'
    } ]), function(nav) {
    return _c('li', [_c('a', {
      class: _vm.type == nav.id ? 'on' : '',
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.changeType(nav.id)
        }
      }
    }, [_vm._v(_vm._s(nav.title))])])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "right"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.waitingSelect),
      expression: "waitingSelect"
    }],
    staticClass: "all",
    class: {
      on: _vm.isSelectedAll
    },
    on: {
      "click": _vm.checkAll
    }
  }, [_vm._v(_vm._s(_vm.isSelectedAll ? "取消全选" : "全选"))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.waitingSelect),
      expression: "waitingSelect"
    }],
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.doDelete()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v("删除")]), _vm._v(" "), _c('button', {
    staticClass: "batch",
    on: {
      "click": function($event) {
        return _vm.typeChange()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.waitingSelect ? "取消" : "批量管理") + "\n        ")])]), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入搜索关键字"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchItem($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "search",
    on: {
      "click": _vm.searchItem
    }
  }, [_vm._v("搜索")])])])]), _vm._v(" "), _c('div', {
    staticClass: "center_content",
    class: {
      'waiting-select': _vm.waitingSelect
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'dubber'),
      expression: "type == 'dubber'"
    }],
    staticClass: "tea-wrap"
  }, [_vm._l((_vm.datas.dubber), function(d) {
    return _c('div', {
      staticClass: "hsktea-recom-wrap lf"
    }, [_c('div', {
      staticClass: "opacity",
      on: {
        "click": function($event) {
          return _vm.selectItem(d)
        }
      }
    }, [_c('i', {
      staticClass: "select",
      class: {
        on: _vm.isSelected(d)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "hsktea-recom-itmes"
    }, [_c('div', {
      staticClass: "recom-items-top"
    }, [_c('div', {
      staticClass: "hsktea-pic"
    }, [_c('a', {
      attrs: {
        "href": '/dubbing/detail/' + d.dubbingId,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgPath(d.dubbingHead)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "hsktea-info"
    }, [_c('a', {
      staticClass: "hsktea-num lf hl",
      attrs: {
        "href": '/dubbing/detail/' + d.dubbingId,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(d.dubbingName))]), _vm._v(" "), _c('p', [_vm._v("交易量：" + _vm._s(d.tranCount))]), _vm._v(" "), _c('p', {
      staticClass: "dis_n"
    }, [_vm._v("已合作老师")])]), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'https://sd235.oss-cn-shanghai.aliyuncs.com/rar/downloads/' +
          d.userNumber +
          '.zip'
      }
    }, [_c('div', {
      staticClass: "hsktea-download",
      attrs: {
        "title": "下载样音包"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "hsktea-price"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [(d.minPrice == 1) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("专题："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("一元配音")])]) : (d.minPrice <= 0) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("专题："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("暂无报价")])]) : (d.minPrice >= 10000) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("专题："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("联系客服")])]) : [_c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("专题:")]), _vm._v(" ￥"), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v(_vm._s(d.minPrice))]), _c('span', {
      domProps: {
        "innerHTML": _vm._s(d.language != '普通话' ? '/百词' : '/分')
      }
    })]], 2), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [(d.adPrice == 1) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("广告："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("一元配音")])]) : (d.adPrice <= 0) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("广告："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("暂无报价")])]) : (d.adPrice >= 10000) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("广告："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("联系客服")])]) : [_c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("广告:")]), _vm._v(" ￥"), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v(_vm._s(d.adPrice))]), _vm._v("/30秒\n              ")]], 2)]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "collect",
      class: d.hasCollect ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.singleCollect(d)
        }
      }
    }, [(d.hasCollect) ? _c('p', [_vm._v("取消收藏" + _vm._s(d.aa))]) : _c('p', [_vm._v("收藏")])])])])
  }), _vm._v(" "), (_vm.datas.dubber.length == 0) ? _c('div', {
    staticClass: "empty_cop"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("您暂无添加收藏过的老师哦~")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/dubbing"
    }
  }, [_vm._v("去看看 >>")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'voice'),
      expression: "type == 'voice'"
    }],
    staticClass: "sea-voice-wrap"
  }, [_c('ul', _vm._l((_vm.datas.voice), function(d, index) {
    return _c('li', {
      staticClass: "voice-items",
      attrs: {
        "sound-id": d.voiceId,
        "dubber-id": d.dubbingId
      }
    }, [_c('i', {
      staticClass: "select",
      class: {
        on: _vm.isSelected(d)
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(d)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "voice_num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "sea-voice-tit lf"
    }, [_c('a', {
      staticClass: "hl",
      attrs: {
        "href": '/voice/detail/' + d.voiceId,
        "target": "_blank",
        "title": ("" + (d.voiceTitle))
      }
    }, [_vm._v(_vm._s(d.voiceTitle))]), _vm._v(" "), _c('i', {
      staticClass: "pop_video",
      attrs: {
        "data-video": "undefined"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sea-voice-tea lf"
    }, [(d.dubbingType == 1) ? _c('a', {
      staticClass: "hl",
      attrs: {
        "title": d.nameExternal,
        "href": 'dubbing/dateil/' + d.dubbingId,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(d.nameExternal))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "sea-voice-down lf"
    }, [_c('a', {
      attrs: {
        "href": _vm.getOSS() + d.filePath,
        "target": "_blank",
        "download": ".mp3",
        "title": "下载样音"
      }
    }, [_vm._v("下载")]), _vm._v(" "), _c('span', {
      staticClass: "rt"
    }, [_vm._v(_vm._s(_vm._f("toBigCount")(d.downloadCount)))])]), _vm._v(" "), _c('div', {
      staticClass: "playCount lf"
    }, [_c('i'), _vm._v(" "), _c('span', {
      staticClass: "rt"
    }, [_vm._v(_vm._s(_vm._f("toBigCount")(d.playCount)))])]), _vm._v(" "), _c('div', {
      staticClass: "opacity",
      on: {
        "click": function($event) {
          return _vm.selectItem(d)
        }
      }
    })])
  }), 0), _vm._v(" "), (_vm.datas.voice.length == 0) ? _c('div', {
    staticClass: "empty_cop"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("您暂无添加收藏过的声音哦~")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/voice"
    }
  }, [_vm._v("去看看 >>")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'album'),
      expression: "type == 'album'"
    }],
    staticClass: "album_area"
  }, [(_vm.datas.album.length == 0) ? _c('div', {
    staticClass: "empty_cop"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("您暂无添加收藏过的合辑哦~")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("去看看 >>")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "album-warp right_content",
    staticStyle: {
      "min-height": "600px"
    }
  }, _vm._l((_vm.datas.album), function(d) {
    return _c('li', {
      staticClass: "album_li"
    }, [_c('i', {
      staticClass: "select",
      class: {
        on: _vm.isSelected(d)
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(d)
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": '/album/detail/' + d.tranSpecialId,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "right_content_color"
    }, [_c('img', {
      attrs: {
        "src": _vm.imgPath(d.specialImgPath),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right_content_text"
    }, [_c('p', {
      staticClass: "content_text_title"
    }, [_vm._v(_vm._s(d.specialName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(d.specialKey))])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding-top": "20px",
        "color": "#9b9b9b"
      }
    }, [_vm._v("\n                共" + _vm._s(d.specialCount) + "条\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "opacity",
      on: {
        "click": function($event) {
          return _vm.selectItem(d)
        }
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap",
    staticStyle: {
      "margin": "0 0 80px 10px"
    }
  }, [_c('sd-pager', {
    attrs: {
      "page-data": _vm.curPage
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hsktea-dub kf_btn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("立即配音")]), _vm._v(" "), _c('div', {
    staticClass: "kf_list_wrap"
  }, [_c('div', {
    staticClass: "kf_list"
  }, [_c('div', {
    staticClass: "arrow_top"
  }, [_c('div', {
    staticClass: "arrow_inner"
  })]), _vm._v(" "), _c('ul')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sea-voice-play lf"
  }, [_c('span', {
    staticClass: "sound-play"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16ac2d32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CollectView.vue
// module id = 846
// module chunks = 1